import { Reducer } from 'redux';
import {
  DEFAULT_EXTRA_ITEM,
  getDefaultFabricationProjectItem,
  DEFAULT_WIRE_ITEM,
  EFabricationOrderSteps,
  EProductType,
  IFabricationPurchaseOrderState,
  Types
} from './types';

export const FABRICATION_ORDER_INITIAL_STATE: IFabricationPurchaseOrderState = {
  fabricationOrderStep: EFabricationOrderSteps.CONSTRUCTION_IDENTIFICATION,
  finishOrderError: false,
  finishOrderLoading: false,

  constructionIdentification: {
    contractNumber: undefined,
    desiredDate: undefined,
    orderNumber: '',
    towers: [],

    cep: '',
    address: '',
    isSingleTower: false,
    state: '',
    city: '',
    observation: ''
  },
  detailingProject: {
    productType: EProductType.VERGALHAO_CORTADO_DOBRADO,
    vehiclesTypes: undefined,
    itens: [getDefaultFabricationProjectItem()],
    observation: ''
  },

  extraItens: {
    otherPieces: [DEFAULT_EXTRA_ITEM],
    annealedWires: [DEFAULT_WIRE_ITEM]
  }
};

type CustomAction = {
  type: Types;
  payload: {
    fabricationPurchaseOrderState: IFabricationPurchaseOrderState;
    fabricationOrderStep: EFabricationOrderSteps;
    createdOrderId: number;
  };
};

const reducer: Reducer<IFabricationPurchaseOrderState, CustomAction> = (
  state = FABRICATION_ORDER_INITIAL_STATE,
  action
) => {
  switch (action.type) {
    case Types.UPDATE_FABRICATION_PURCHASE_ORDER_SETTINGS:
      return { ...state, ...action.payload.fabricationPurchaseOrderState };

    case Types.UPDATE_FABRICATION_STEP:
      return {
        ...state,
        fabricationOrderStep: action.payload.fabricationOrderStep
      };

    case Types.FINISH_ORDER:
      return {
        ...state,
        ...action.payload.fabricationPurchaseOrderState,
        finishOrderLoading: true,
        finishOrderError: false
      };

    case Types.FINISH_ORDER_SUCCESS:
      return {
        ...state,
        createdOrderId: action.payload.createdOrderId,
        finishOrderLoading: false
      };

    case Types.FINISH_ORDER_FAILURE:
      return { ...state, finishOrderLoading: false, finishOrderError: true };

    case Types.CLEAN_FABRICATION_PURCHASE_ORDER_SETTINGS:
      return FABRICATION_ORDER_INITIAL_STATE;

    default:
      return state;
  }
};

export default reducer;
